import './ChartOverlaysBorder.css';
export var chartOverlaysBorder = '_sw8x1w0-3-8-0';
export var chartOverlaysBorder__rightAxis = '_sw8x1w2-3-8-0';
export var chartOverlaysBorder__topAxis = '_sw8x1w4-3-8-0';
export var chartOverlaysBorder__xAxis = '_sw8x1w1-3-8-0';
export var chartOverlaysBorder__yAxis = '_sw8x1w3-3-8-0';